var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-b-toolsbar-wrap"},[_c('div',{staticClass:"feedback1",attrs:{"target":"_blank","title":"双11钜惠"},on:{"click":function($event){return _vm.gotoActivity()}}},[_c('span',{staticClass:"right__mascot"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }